import { FiBox } from "react-icons/fi";

export default function PropIcon(props: { size: number }) {
  return FiBox({ size: props.size }) as React.ReactElement;
}
